import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetOrganization, GetUserRating, PostUserRating } from "../../engine/baseApiClient";

const initialState = {
    layoutSettings: {
        paletteMode: 'light'
    },
    accountSettings: {

    },
    organizationSettings: {
        bankAccounts: [],
        company: {
            name: '',
            nip: {
                nip: ''
            },
            address: {
                country: 'PL',
                city: '',
                street: '',
                houseNumber: '',
                apartmentNumber: '',
                zipCode: ''
            },
            email: '',
            phone: '',
            cellPhone: ''
        },
        automaticSendingOfDocuments: {
            enabled: false,
            emails: []
        }
    },
    userRating: {
        rating: 0,
        comment: '',
        submitted: false
    }
};

export const doFetchOrganizationDataAsync = createAsyncThunk(
    "user/doFetchOrganizationDataAsync",
    async () => {
        const response = await GetOrganization();
        return response;
    }
);

export const doFetchUserRatingAsync = createAsyncThunk(
    "user/doFetchUserRatingAsync",
    async () => {
        const response = await GetUserRating();
        return response;
    }
);

export const doPostUserRatingAsync = createAsyncThunk(
    "user/doPostUserRatingAsync",
    async (payload) => {
        const response = await PostUserRating(payload);
        return response;
    }
);

export const userSlice = createSlice({
    name: 'user',
    initialState: initialState,
    reducers: {
        doSetDarkPaletteMode: (state) => {
            state.layoutSettings.paletteMode = 'dark';
        },
        doSetLightPaletteMode: (state) => {
            state.layoutSettings.paletteMode = 'light';
        },
        doSetUserRating: (state, action) => {
            state.userRating = {
                submitted: false,
                rating: action?.payload?.rating,
                comment: action?.payload?.comment
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(doFetchOrganizationDataAsync.fulfilled, (state, action) => {
                if(action.payload.organization != undefined) {
                    if( action.payload.organization.company != undefined) {
                        state.organizationSettings.company = action.payload.organization.company;                        
                    }

                    if( action.payload.organization.bankAccounts != undefined) {
                        state.organizationSettings.bankAccounts = action.payload.organization.bankAccounts;
                    }

                    if( action.payload.organization.automaticSendingOfDocuments != undefined) {
                        state.organizationSettings.automaticSendingOfDocuments = action.payload.organization.automaticSendingOfDocuments;
                    }
                }                
            })
            .addCase(doPostUserRatingAsync.fulfilled, (state, action) => {
                if(action?.payload?.userRating !== undefined) {
                    state.userRating.submitted = true;
                    state.userRating.rating = action?.payload?.userRating.rating;
                    state.userRating.comment = action?.payload?.userRating.comment;
                }
            })
            .addCase(doFetchUserRatingAsync.fulfilled, (state, action) => {
                if(action?.payload?.userRating !== undefined) {
                    state.userRating.submitted = true;
                    state.userRating.rating = action?.payload?.userRating.rating;
                    state.userRating.comment = action?.payload?.userRating.comment;
                }
            })
    }
});

export const selectLayoutSettings = (state) => state.user.layoutSettings;
export const selectAccountSettings = (state) => state.user.accountSettings;
export const selectOrganizationSettings = (state) => state.user.organizationSettings;
export const selectUserRating = (state) => state.user.userRating;
export const { doSetDarkPaletteMode, doSetLightPaletteMode, doSetUserRating } = userSlice.actions;
export default userSlice.reducer;
